import React from 'react';
import { Section } from './UiTemplateGallery.styles';
import { Column, Container, Row } from '../../components';
import { FullWidthCarousel, TrelloTemplate } from './components';
export default function UiTemplateGalleryProps({ model }) {
    const { templates, carousel, reduced } = model.content;
    return (React.createElement(Section, { "data-testid": "template-gallery" }, carousel ? (React.createElement(FullWidthCarousel, { arrows: true, templates: templates, reduced: reduced })) : (React.createElement(Container, null,
        React.createElement(Row, { align: "center" }, templates
            .filter(({ type }) => type === 'trelloTemplate')
            .map((template, index) => (React.createElement(Column, { md: { span: '6' }, lg: { span: '4' }, key: index },
            React.createElement(TrelloTemplate, { model: template, reduced: reduced })))))))));
}
//# sourceMappingURL=UiTemplateGallery.js.map